export const myTheme = {
  link: '#34657f',
  body: {
    text: '#333333'
  },
  field: {
    focus: '#3e8529'
  },
  button: {
    primary: {
      text: '#FFFFFF',
      hover: '#3e8529'
    },
    secondary: {
      hover: '#FFFFFF'
    },
    // text and icon color
    text: '#34657F',
    background: '#3e8529' // sets bg and border
  },
  footer: {
    background: '#FFFFFF',
    text: "#000"
  }
};